import {
  BellOutlined,
  BellTwoTone,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';

import {
  Badge,
  Button,
  Col,
  Flex,
  Row,
  Space,
  Typography,
} from 'antd';

import { Header } from 'antd/es/layout/layout';
import { useSelector } from 'react-redux';

import ProfileMenu from "./comp/ProfileMenu";
import DateRange from './comp/DateRange';
import SimpleDialogDemo from "./zerodhaDilogbox";

const Topbar = (props) => {

  const { Text } = Typography;

  const {
    collapsed,
    setCollapsed,
    screens,
  } = props;

  const { userInfo } = useSelector((state) => state.auth);

  return (
    <Header
      style={{
        padding: 0,
        background: "#1b1b1b",
        boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.35)",
        borderBottom: "1px solid #2f2f2f",
      }}
    >

      <Row
        style={{
          paddingLeft: "5px",
          paddingRight: "5px",
        }}
      >

        <Col flex="auto">

          <Button
            type="text"
            shape="circle"
            icon={
              collapsed
                ? <MenuUnfoldOutlined style={{ color: "#CB9E52" }} />
                : <MenuFoldOutlined style={{ color: "#CB9E52" }} />
            }
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              marginLeft: "10px",
            }}
          />

          <Text
            style={{
              color: "#999999",
            }}
          >
            Beta v1.0.1
          </Text>

        </Col>

        <Col flex="none">

          <Space size="middle">

            {screens.lg ? (
              <DateRange />
            ) : (
              <></>
            )}

            <ProfileMenu
              collapsed={collapsed}
              screens={screens}
              userInfo={userInfo}
            />

          </Space>

        </Col>

        <Col flex="none">

          {screens.md && (
            <div
              style={{
                marginRight: "15px",
                display: "flex",
                alignItems: "center",
                paddingTop: screens.xs ? "0px" : "22px",
              }}
            >
              {/* <SimpleDialogDemo /> */}
            </div>
          )}

        </Col>

      </Row>

    </Header>
  );
};

export default Topbar;
